import { c as _c } from "react/compiler-runtime";
import { Box, Container, Typography } from "@mui/material";
import React from "react";
export const Footer: React.FC = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Container component="footer"><Box mt={4} mb={2}><Typography variant="caption">© Max Kayander, 2026.</Typography></Box></Container>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};